module.exports = __webpack_public_path__ + "static/media/btn_treeFace_active.fadc91d9.png";